
import { Component, Vue } from "vue-property-decorator";
import {
  dispatchGetVirtualNodesActive
} from "@/store/mlm/actions";
import {
  readVirtualNodesActive
} from "@/store/mlm/getters";
import PackageUpgradeVirtualModal from '@/components/Main/Nodes/PackageUpgradeVirtualModal.vue';
import { IAcquiredNode } from "@/interfaces/mlm";
@Component({
  components: {
    PackageUpgradeVirtualModal
  },
})
export default class VirtualNodesActive extends Vue {

    public tariffUpgradeModal = false;
  public currentTariff: IAcquiredNode | null = null;
  
  // methods
  public handleCloseTariffUpgradeModal() {
    this.tariffUpgradeModal = false;
  }

public handleOpenTariffUpgradeModal(current_tariff:IAcquiredNode) {
    this.currentTariff = current_tariff
    this.tariffUpgradeModal = true;
  }

public async mounted() {
  if(this.virtualNodesActive.length == 0){
        await dispatchGetVirtualNodesActive(this.$store)
    }
}

 get virtualNodesActive() {
    return readVirtualNodesActive(this.$store)
  }

  get sortedAcquiredNodes() {
    return [...this.virtualNodesActive].sort((a, b) => {
      const orderIdA = a.order_id || 0;
      const orderIdB = b.order_id || 0;
      return orderIdA - orderIdB;
    });
  }

   get tariffOrder(): Record<string, number> {
  return {
    Beginner: 0,
    Light: 1,
    Medium: 2,
    Professional: 3,
  };
}
  
}
